import React, { useState } from 'react';
import { Button, Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';

const TopBar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleProfile = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleSignOut = async () => {
    try {
      console.log('[DEBUG_LOG] TopBar - Starting sign out process');
      await Auth.signOut();
      console.log('[DEBUG_LOG] TopBar - Sign out successful, redirecting to home page');
      window.location.href = '/';
    } catch (error) {
      console.error('[DEBUG_LOG] TopBar - Error signing out:', error);
    }
  };


  return (
    <div className="topbar">
      { /* <div className="menu-button" /> */ }
      <div className="logo-container">
        <Link to="/">
          <div className="logo" />
        </Link>
      </div>
      <div className="user-container">
        <button type="button" className="user-button" aria-label="Profile" onClick={toggleProfile}>
          <div className="icon" />
        </button>
        {isCollapsed && (
          <button
            className="topbar__back"
            type="button"
            aria-label="profile button"
            onClick={toggleProfile}
          />
        )}
        <Collapse isOpen={isCollapsed} className="topbar-menu-wrap">
          <div className="topbar-menu">
            <Button onClick={handleSignOut} style={{ borderRadius: 0, backgroundColor: '#4be1b6' }}>Logout</Button>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default TopBar;
